import React from 'react';
import { compose } from 'recompose';
import PropTypes from 'prop-types';

import Typography from '@material-ui/core/Typography/Typography';

import { withStyles } from '@material-ui/core/styles';
import { COLORS, commonStyles } from '../styles/styles';
import { STATUSES } from '../constants';

import { MDBBadge, MDBContainer } from "mdbreact";

const getStatusName = status => {

  switch (status) {
    case STATUSES.nycompetent.name:
      return STATUSES.nycompetent.display;
    case STATUSES.competent.name:
      return STATUSES.competent.display;
    case STATUSES.tii_pending.name:
      return STATUSES.tii_pending.display;
    case STATUSES.notStarted.name:
      return STATUSES.notStarted.display;
    case STATUSES.completed.name:
      return STATUSES.completed.display;
    case STATUSES.inProgress.name:
      return STATUSES.inProgress.display;
      case STATUSES.declined.name:
        return STATUSES.declined.display;
      case STATUSES.pending.name:
        return STATUSES.pending.display;
    case STATUSES.extension_request.name:
      return STATUSES.extension_request.display;
    case STATUSES.resubmission_request.name:
      return STATUSES.resubmission_request.display;
    case STATUSES.ready.name:
      return STATUSES.ready.display;
      case STATUSES.ready2.name:
        return STATUSES.ready2.display;
    case STATUSES.reviewed.name:
        return STATUSES.reviewed.display;
    case STATUSES.draft.name:
      return STATUSES.draft.display;
      case STATUSES.ready.name:
        return STATUSES.ready.display;
    case STATUSES.marking.name:
        return STATUSES.marking.display;
    case STATUSES.submitted.name:
      return STATUSES.submitted.display;
    case STATUSES.locked.name:
      return STATUSES.locked.display;
      case STATUSES.waiting.name:
        return STATUSES.waiting.display;
    default:
      return COLORS.yellow;
  }
};

const getStatusClass = status => {
  
  switch (status) {
    case STATUSES.nycompetent.name:
      return 'warning-color';
    case STATUSES.competent.name:
      return 'completed-color';
    case STATUSES.tii_pending.name:
      return 'info-color';
    case STATUSES.notStarted.name:
      return 'danger-color-dark';
    case STATUSES.declined.name:
      return 'danger-color-dark';
    case STATUSES.pending.name:
        return 'success-color';
  case STATUSES.completed.name:
      return 'completed-color';
  case STATUSES.inProgress.name:
      return 'warning-color';
  case STATUSES.draft.name:
        return 'warning-color';
  case STATUSES.reviewed.name:
    return 'success-color';
  case STATUSES.ready.name:
      return 'success-color';
      case STATUSES.ready2.name:
      return 'success-color';
  case STATUSES.extension_request.name:
      return 'warning-color';
  case STATUSES.resubmission_request.name:
      return 'warning-color';
  case STATUSES.marking.name:
      return 'warning-color';
  case STATUSES.submitted.name:
    return 'success-color';
  case STATUSES.extension_request.name:
      return 'warning-color';
  case STATUSES.ready.name:
    return 'success-color';
  case STATUSES.locked.name:
    return 'danger-color';
    case STATUSES.waiting.name:
    return 'info-color';

  default:
    return 'warning-color';
  }
};

const CardStatus = ({ classes, status }) => (
  <MDBBadge pill color={getStatusClass(status)} className='text-white'>{getStatusName(status)}</MDBBadge>
);

CardStatus.propTypes = {
  classes: PropTypes.instanceOf(Object),
  status: PropTypes.string,
};

const styles = theme => ({
  ...commonStyles,
  headerHolder:{
    position:'absolute', 
    right:2, 
    top:92,
  },
  headerWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    float:'right'
  },
  status: {
    color: '#fff',
    display: 'flex',
    fontSize: theme.typography.fontSize - 4,
    textTransform: 'uppercase',
    fontWeight: theme.typography.fontWeightLight,
    borderRadius:4,
    padding: '4px 10px',
  },
});

export default compose(withStyles(styles))(CardStatus);
